module.exports = __webpack_public_path__ + "static/media/trial1_4.45d518ca.png";